const docDropdown = () => {
  const documentFile = document.querySelectorAll('[data-doc-menu]')

  documentFile &&
    documentFile.forEach((doc) => {
      const toggle = doc.querySelectorAll('[data-doc-menu-toggle]')
      const dropdown = doc.querySelector('[data-doc-menu-dropdown]')

      toggle.forEach((button) => {
        button.addEventListener('click', () => {
          dropdown.classList.toggle('is-hidden')
        })
      })
    })
}

const managerList = document.querySelector('[data-manager-list]')
const observer = new MutationObserver(docDropdown)

if (
  managerList &&
  managerList.getAttribute('data-manager-list') === 'documents'
) {
  observer.observe(managerList, {
    childList: true,
    subtree: true,
  })
}

document.addEventListener('DOMContentLoaded', docDropdown)
